import * as _ from 'lodash';
import { Button, Flex, Icon, Label } from '@vibe/core';
import { AppModal, AppModalContent } from '@gorilla/ui/src/components/AppModal';
import { Completed } from '@vibe/icons';

type ExperimentalSpreadsheetModalProps = {
  show: boolean;
  onClose: () => void;
};

export default function ExperimentalSpreadsheetModal({ show, onClose }: ExperimentalSpreadsheetModalProps) {
  return (
    <AppModal
      show={show}
      onClose={() => {
        onClose();
      }}
      alertDialog={true}
      id="experimental--dialog"
    >
      <AppModalContent>
        <Flex gap={10}>
          <h2>Spreadsheet viewer</h2>
          <Label text="Deprecated" color="negative" />
        </Flex>
        <p style={{ marginBottom: '8px' }}>
          The spreadsheet viewer is now flagged as deprecated and will be completely <strong>removed from the app in April 2026</strong>. To
          keep taking snapshots from your spreadsheet templates, we recommend setting up an automation.
        </p>
      </AppModalContent>
    </AppModal>
  );
}
